// READ-1536: Set reader-specific cookie, unix timestamp for value
const appCookieName = 'mlreader';

const getCookie = () => {
  const v = document.cookie.match('(^|;) ?' + appCookieName + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

const checkCookie = () => {
  if (!getCookie()) {
    const mlReaderCookieValue = parseInt((new Date().getTime() / 1000).toFixed(0));
    document.cookie = `${appCookieName}=${mlReaderCookieValue}; path=/`;
  }
};

export default checkCookie;
